<p-dialog
  [header]="title"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '1100px', height: '90vh', maxHeight: '90vh' }"
  [breakpoints]="{ '960px': '95vw' }"
  styleClass="rich-text-editor-dialog"
>
  <!-- Lazily mount TinyMCE only while the dialog is open so it never
       initialises (or loads its script) on a closed/idle sheet. A skeleton
       overlays the editor until TinyMCE fires `onInit`, masking the load flash. -->
  <div class="rte-editor-wrap" *ngIf="visible">
    <editor
      [(ngModel)]="workingHtml"
      [init]="editorInit"
      licenseKey="gpl"
      outputFormat="html"
      (onInit)="onEditorInit($event)"
      (onKeyUp)="recomputeDirty()"
      (onChange)="recomputeDirty()"
      (onExecCommand)="recomputeDirty()"
      (onUndo)="recomputeDirty()"
      (onRedo)="recomputeDirty()"
    ></editor>

    <!-- Mirrors the TinyMCE layout: a header band (menubar + toolbar rows) and
         the editing surface below it. -->
    <div class="rte-skeleton" *ngIf="!editorReady" aria-hidden="true">
      <p-skeleton width="100%" height="4.75rem" styleClass="rte-skeleton-header"></p-skeleton>
      <p-skeleton width="100%" height="100%" styleClass="rte-skeleton-body"></p-skeleton>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <!-- Buttons mirror the logout confirm dialog (user-signout.component):
         taxpod-blue colour, 100px width, Lato font, bold primary. -->
    <div class="rte-footer">
      <p-button
        label="Close"
        (onClick)="onCancel()"
        variant="outlined"
        styleClass="!w-[100px] xlplus:!w-[100px] !border-taxpod-blue !text-taxpod-blue !border-[1.5px] !text-sm xlplus:!text-base !font-lato hover:!bg-[#E0F2FE]"
      />
      <p-button
        label="Save"
        [disabled]="!dirty"
        (onClick)="onSave()"
        styleClass="!w-[100px] xlplus:!w-[100px] !bg-taxpod-blue !border-taxpod-blue !border-[1.5px] !text-sm xlplus:!text-base !font-lato !font-bold disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
      />
    </div>
  </ng-template>
</p-dialog>
